import { Pipe, PipeTransform } from '@angular/core';
import { UserRoleItem } from '../../api/models';
import { enumBookingStatus } from '../utils/enum-booking-status';

@Pipe({ name: 'bookingStatus' })
export class BookingStatusPipe implements PipeTransform {
  transform(id: number, ...args: boolean[]): string {
    switch (id) {
      case enumBookingStatus.PAYMENT_PROCESSING:
        return `<div class="transfer processing" pTooltip="In corso" tooltipPosition="top"></div>`;
      // case enumBookingStatus.ADVANCE_PAYED:
      //   return `<div class="transfer adv_payed" pTooltip="Acconto pagato" tooltipPosition="top"></div>`;
      case enumBookingStatus.PAYED:
        return `<div class="transfer payed" pTooltip="Pagato" tooltipPosition="top"></div>`;
      case enumBookingStatus.SUSPENDED:
        return `<div class="transfer suspended" pTooltip="Sospeso" tooltipPosition="top"></div>`;
      case enumBookingStatus.REFUNDED:
        return `<div class="transfer refunded" pTooltip="Rimborsato" tooltipPosition="top"></div>`;
      case enumBookingStatus.CANCELED:
        return `<div class="transfer canceled" pTooltip="Cancellato" tooltipPosition="top"></div>`;
    }
    return ``;
  }
}
